import React, { ReactNode } from "react"
import { blokType } from "../../types"
import Item from "./Item"
import { StyledAccordion } from "./partials"

export interface AccordionProps {
  items: blokType[]
  microdata: boolean,
}

export const AccordionCmp: React.FC<AccordionProps> = ({ items, microdata }) => (
  <div data-name="accordion">
    {items && (
      <StyledAccordion>
        {items.map((content: blokType) => (
          <div
            itemScope
            itemProp={microdata ? "mainEntity" : undefined}
            itemType={microdata ? "https://schema.org/Question" : undefined}
          >
            <Item
              title={content.title}
              default_open={content.default_open}
              description={content.description}
              microdata={microdata}
              key={content._uid}
            />
          </div>
        ))}
      </StyledAccordion>
    )}
  </div>
)
